import { LegalLayout } from "../components/LegalLayout";
import { Seo } from "../components/Seo";

const H2 = ({ children }) => (
  <h2 className="font-heading text-2xl md:text-3xl font-bold uppercase tracking-tight text-white mt-12 mb-4">
    {children}
  </h2>
);
const H3 = ({ children }) => (
  <h3 className="font-heading text-lg md:text-xl font-semibold text-white mt-8 mb-3">
    {children}
  </h3>
);

export default function Confidentialite() {
  return (
    <>
      <Seo
        title="Politique de confidentialité — PDR France"
        description="Politique de confidentialité et protection des données personnelles de PDR France, conforme RGPD et loi Informatique et Libertés (CNIL)."
        path="/confidentialite"
      />
      <LegalLayout
      title="Politique de confidentialité"
      eyebrow="Protection des données · RGPD"
      lastUpdate="Décembre 2025"
    >
      <p>
        La présente politique de confidentialité a pour objet
        d'informer les utilisateurs du site pdrfrance.fr sur la manière
        dont leurs données personnelles sont collectées et traitées,
        conformément au Règlement Général sur la Protection des Données
        (RGPD · Règlement UE 2016/679) et à la loi française
        « Informatique et Libertés » du 6 janvier 1978 modifiée.
      </p>

      <H2>1. Responsable du traitement</H2>
      <p>
        Le responsable du traitement des données personnelles collectées
        sur ce site est :
      </p>
      <ul className="space-y-2 list-none pl-0">
        <li><strong className="text-white">PDR FRANCE</strong> (EURL · SIREN 944 868 678)</li>
        <li>Adresse : Chez M. EL OUAZZANI Youssef, 1305 route de Faverange, 42230 Saint-Étienne</li>
        <li>Email : debosselage@pdrfrance.fr</li>
        <li>Téléphone : 07 73 11 90 16</li>
      </ul>

      <H2>2. Données collectées</H2>
      <p>
        Dans le cadre de l'utilisation du site et des services proposés,
        nous pouvons être amenés à collecter les catégories de données
        suivantes :
      </p>
      <H3>2.1 Données que vous nous communiquez directement</H3>
      <ul className="list-disc list-inside space-y-1 text-white/75">
        <li>Identité : nom, prénom</li>
        <li>Coordonnées : adresse email, numéro de téléphone, adresse postale</li>
        <li>Informations sur votre véhicule : marque, modèle, immatriculation, nature du sinistre</li>
        <li>Contenu de vos messages envoyés via les formulaires de contact</li>
      </ul>
      <H3>2.2 Données collectées automatiquement</H3>
      <ul className="list-disc list-inside space-y-1 text-white/75">
        <li>Adresse IP, type et version de navigateur, système d'exploitation</li>
        <li>Pages visitées, durée de visite, date et heure de connexion</li>
        <li>Informations issues des cookies (voir notre politique de cookies)</li>
      </ul>

      <H2>3. Finalités du traitement</H2>
      <p>Les données sont collectées pour les finalités suivantes :</p>
      <ul className="list-disc list-inside space-y-1 text-white/75">
        <li>Répondre à vos demandes de devis ou de renseignements</li>
        <li>Gérer les relations commerciales et contractuelles</li>
        <li>Assurer le suivi des sinistres et la gestion avec les assurances</li>
        <li>Réaliser des statistiques de fréquentation anonymisées</li>
        <li>Respecter nos obligations légales et réglementaires</li>
      </ul>

      <H2>4. Base légale du traitement</H2>
      <p>Le traitement de vos données repose sur :</p>
      <ul className="list-disc list-inside space-y-1 text-white/75">
        <li><strong className="text-white">Votre consentement</strong> pour les cookies non essentiels et les communications marketing</li>
        <li><strong className="text-white">L'exécution d'un contrat</strong> ou de mesures précontractuelles (devis, commande)</li>
        <li><strong className="text-white">L'intérêt légitime</strong> de PDR FRANCE pour la sécurité du site et la prévention de la fraude</li>
        <li><strong className="text-white">Le respect d'obligations légales</strong> (comptabilité, lutte contre la fraude)</li>
      </ul>

      <H2>5. Destinataires des données</H2>
      <p>
        Vos données sont exclusivement destinées à PDR FRANCE et à ses
        sous-traitants agissant pour son compte (hébergeur, prestataires
        techniques, partenaires assurance dans le cadre de la gestion de
        sinistres). Aucune donnée n'est vendue à des tiers.
      </p>

      <H2>6. Durée de conservation</H2>
      <ul className="list-disc list-inside space-y-1 text-white/75">
        <li>Demandes de contact / devis : 3 ans à compter du dernier contact</li>
        <li>Dossiers clients : durée de la relation commerciale + 10 ans (obligations comptables)</li>
        <li>Données de connexion (logs) : 12 mois maximum</li>
        <li>Cookies : 13 mois maximum</li>
      </ul>

      <H2>7. Vos droits</H2>
      <p>
        Conformément au RGPD et à la loi Informatique et Libertés, vous
        disposez des droits suivants :
      </p>
      <ul className="list-disc list-inside space-y-1 text-white/75">
        <li><strong className="text-white">Droit d'accès</strong> : obtenir la confirmation que des données vous concernant sont traitées et en recevoir copie</li>
        <li><strong className="text-white">Droit de rectification</strong> : corriger des données inexactes</li>
        <li><strong className="text-white">Droit à l'effacement</strong> (« droit à l'oubli ») : demander la suppression de vos données</li>
        <li><strong className="text-white">Droit à la limitation</strong> du traitement</li>
        <li><strong className="text-white">Droit à la portabilité</strong> de vos données</li>
        <li><strong className="text-white">Droit d'opposition</strong> au traitement</li>
        <li><strong className="text-white">Droit de retirer votre consentement</strong> à tout moment</li>
        <li><strong className="text-white">Droit de définir des directives</strong> relatives au sort de vos données après votre décès</li>
      </ul>
      <p>
        Pour exercer ces droits, contactez-nous à :{" "}
        <a href="mailto:debosselage@pdrfrance.fr" className="text-[#007AFF] hover:underline">
          debosselage@pdrfrance.fr
        </a>{" "}
        en joignant une copie d'un justificatif d'identité.
      </p>
      <p>
        Si vous estimez, après nous avoir contactés, que vos droits ne
        sont pas respectés, vous pouvez adresser une réclamation à la{" "}
        <a
          href="https://www.cnil.fr"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#007AFF] hover:underline"
        >
          CNIL (Commission Nationale de l'Informatique et des Libertés)
        </a>
        .
      </p>

      <H2>8. Sécurité</H2>
      <p>
        PDR FRANCE met en œuvre des mesures techniques et
        organisationnelles appropriées pour garantir la sécurité et la
        confidentialité de vos données (chiffrement HTTPS, accès
        restreint, sauvegardes régulières).
      </p>

      <H2>9. Transferts hors UE</H2>
      <p>
        Vos données sont traitées au sein de l'Union européenne. En cas
        de transfert hors UE, PDR FRANCE s'assure que des garanties
        appropriées sont mises en place (clauses contractuelles types,
        décision d'adéquation).
      </p>

      <H2>10. Modifications</H2>
      <p>
        La présente politique peut être modifiée à tout moment pour
        refléter les évolutions légales ou les changements dans nos
        pratiques. Nous vous invitons à la consulter régulièrement.
      </p>
    </LegalLayout>
    </>
  );
}
